import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { connect } from 'react-redux';
import { loaderStateTrue, loaderStateFalse, handleActiveLink } from '../../../Actions/AllAction';
import Utility from '../../Utility/Utility';
import AutosuggestComponent from '../../Utility/Components/AutosuggestComponent'
import CustomInput from '../../Utility/Components/CustomInput'
import ErrorBoundary from '../../Utility/Components/ErrorBoundary';
import PhoneNumberWithCountryCode from '../../Utility/Components/PhoneNumberWithCountryCode';
import ModalGlobal from '../../Utility/Components/ModalGlobal';
import ImageCropContent from '../../Utility/Components/ImageCropContent';
import { withNamespaces } from 'react-i18next';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import BankDetailsContent from './BankDetailsContent'
import TimezoneSelect from 'react-timezone-select';


function HotelAddEditModalContent(props) {

    return (
        <div className="gridcontainer">
            <div className="modalinnerbody">
                <div className="innerbodydimension">
                    <div className='col-md-12'>
                        <h3 className='admin_details_label'>Organization Details</h3>
                        <div className='divider_row'></div>
                    </div>
                    <div className="col-md-12">
                        <div className="row">
                            <div className='col-md-9'>
                                <div className='row'>
                                    <div className="col-md-6">
                                        <ErrorBoundary title="CustomInput Error">
                                            <CustomInput
                                                parentClassName="input_field_inner"
                                                labelName="Organization Name"
                                                errorLabel={props.errorFormData.hotel_name}
                                                name="hotel_name"
                                                type="text"
                                                value={props.formData.hotel_name}
                                                labelPresent={true}
                                                onChange={(e) => props.handelChange(e, 'hotel_name')}
                                            />
                                        </ErrorBoundary>
                                    </div>
                                    <div className="col-md-6">
                                        <ErrorBoundary title="CustomInput Error">
                                            <CustomInput
                                                parentClassName="input_field_inner"
                                                labelName="Email"
                                                errorLabel={props.errorFormData.hotel_email}
                                                name="hotel_email"
                                                type="text"
                                                value={props.formData.hotel_email}
                                                labelPresent={true}
                                                onChange={(e) => props.handelChange(e, 'hotel_email')}
                                            />
                                        </ErrorBoundary>
                                    </div>
                                    <div className="col-md-6">
                                        <ErrorBoundary title="CustomInput Error">
                                            <CustomInput
                                                parentClassName="input_field_inner"
                                                labelName="Address 1"
                                                errorLabel={props.errorFormData.hotel_address1}
                                                name="hotel_address1"
                                                type="text"
                                                value={props.formData.hotel_address1}
                                                labelPresent={true}
                                                onChange={(e) => props.handelChange(e, 'hotel_address1')}
                                            />
                                        </ErrorBoundary>
                                    </div>
                                    <div className="col-md-6">
                                        <ErrorBoundary title="CustomInput Error">
                                            <CustomInput
                                                parentClassName="input_field_inner"
                                                labelName="Address 2"
                                                errorLabel={props.errorFormData.hotel_address2}
                                                name="hotel_address2"
                                                type="text"
                                                value={props.formData.hotel_address2}
                                                labelPresent={true}
                                                onChange={(e) => props.handelChange(e, 'hotel_address2')}
                                                requiredStar={false}
                                            />
                                        </ErrorBoundary>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <label className='orgLogoLabel'>Organization Logo <span style={{ color: 'red' }}>*</span></label>
                                <div className="user_add_img modprofile hotel_img_container">
                                    <div className="userProfileImg">
                                        {!props.addHotelImagePreviewShow ?
                                            <OverlayTrigger overlay={<Tooltip className="my-custom-tooltip"> Upload Organization Logo</Tooltip>}>
                                                <label className="custom-file-upload">
                                                    <span className="filetext">
                                                        <img src={props.addHotelImageSelected} />
                                                    </span>
                                                    <span className="plusicon">
                                                        <i className="fa fa-plus" aria-hidden="true"></i>
                                                        <input type="file" onChange={props.addInputHotelImageChanged} />
                                                    </span>
                                                </label></OverlayTrigger> :
                                            <OverlayTrigger overlay={<Tooltip className="my-custom-tooltip">Organization Logo</Tooltip>}>
                                                <label className="custom-file-upload">
                                                    <img src={props.addHotelImageSelected} />
                                                    <span className="plusicon">
                                                        <i className="fa fa-plus" aria-hidden="true"></i>
                                                        <input type="file" onChange={props.addInputHotelImageChanged} />
                                                    </span>
                                                </label></OverlayTrigger>}

                                        <div className="col-md-12 errorClass error_div">{props.errorFormData.hotel_image}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="row">
                            {/* <div className="col-md-4">
                                <ErrorBoundary title="CustomInput Error">
                                    <CustomInput
                                        parentClassName="input_field_inner"
                                        labelName="Hotel Name"
                                        errorLabel={props.errorFormData.hotel_name}
                                        name="hotel_name"
                                        type="text"
                                        value={props.formData.hotel_name}
                                        labelPresent={true}
                                        onChange={(e) => props.handelChange(e, 'hotel_name')}
                                    />
                                </ErrorBoundary>
                            </div>
                            <div className="col-md-4">
                                <ErrorBoundary title="CustomInput Error">
                                    <CustomInput
                                        parentClassName="input_field_inner"
                                        labelName="Email"
                                        errorLabel={props.errorFormData.hotel_email}
                                        name="hotel_email"
                                        type="text"
                                        value={props.formData.hotel_email}
                                        labelPresent={true}
                                        onChange={(e) => props.handelChange(e, 'hotel_email')}
                                    />
                                </ErrorBoundary>
                            </div>

                            <div className="col-md-4">
                                <ErrorBoundary title="CustomInput Error">
                                    <CustomInput
                                        parentClassName="input_field_inner"
                                        labelName="Address 1"
                                        errorLabel={props.errorFormData.hotel_address1}
                                        name="hotel_address1"
                                        type="text"
                                        value={props.formData.hotel_address1}
                                        labelPresent={true}
                                        onChange={(e) => props.handelChange(e, 'hotel_address1')}
                                    />
                                </ErrorBoundary>
                            </div>
                            <div className="col-md-4">
                                <ErrorBoundary title="CustomInput Error">
                                    <CustomInput
                                        parentClassName="input_field_inner"
                                        labelName="Address 2"
                                        errorLabel={props.errorFormData.hotel_address2}
                                        name="hotel_address2"
                                        type="text"
                                        value={props.formData.hotel_address2}
                                        labelPresent={true}
                                        onChange={(e) => props.handelChange(e, 'hotel_address2')}
                                        requiredStar={false}
                                    />
                                </ErrorBoundary>
                            </div> */}


                            <div className="col-md-4">
                                <ErrorBoundary title="CustomInput Error">
                                    <CustomInput
                                        parentClassName="input_field_inner"
                                        labelName="Zip Code"
                                        errorLabel={props.errorFormData.hotel_zip_code}
                                        name="hotel_zip_code"
                                        type="text"
                                        value={props.formData.hotel_zip_code}
                                        labelPresent={true}
                                        onChange={(e) => props.handelChange(e, 'hotel_zip_code')}
                                    />
                                </ErrorBoundary>
                            </div>
                            <div className="col-md-4">
                                <ErrorBoundary title="CustomInput Error">
                                    <div className="dropdowninnerboxContainer">
                                        <label>Country <span>*</span></label>
                                        <AutosuggestComponent
                                            handleOnChange={(e) => props.handelChange(e, 'hotel_country')}
                                            options={props.CountryList}
                                            selectedValue={props.selectedCountry}
                                            name=''
                                            isMulti={false}
                                            placeholder=""
                                            isDisabled={false}
                                            isSearchable={true}
                                            classNamePrefix="dropdown-default"
                                            menuPosition="fixed"
                                        />
                                    </div>
                                    <div className="col-md-12 errorClass error_div">{props.errorFormData.hotel_country}</div>
                                </ErrorBoundary>
                            </div>
                            <div className="col-md-4">
                                <div className='input_field_inner_phone'>
                                    <ErrorBoundary title="PhoneInput Error">
                                        <PhoneNumberWithCountryCode
                                            country={props.selectedCountryCode}
                                            value={props.formData.hotel_contact_number}
                                            onChange={(e, country) => props.handelChange(e, 'hotel_contact_number', country)}
                                            error={props.errorFormData.hotel_contact_number}
                                            labelShow={true}
                                            requirStart={true}
                                            disableDropdown={true}
                                        />
                                    </ErrorBoundary>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <ErrorBoundary title="CustomInput Error">
                                    <div className="dropdowninnerboxContainer">
                                        <label>State <span>*</span></label>
                                        <AutosuggestComponent
                                            handleOnChange={(e) => props.handelChange(e, 'hotel_state')}
                                            options={props.StateList}
                                            selectedValue={props.selectedState}
                                            name=''
                                            isMulti={false}
                                            placeholder=""
                                            isDisabled={false}
                                            isSearchable={true}
                                            classNamePrefix="dropdown-default"
                                            menuPosition="fixed"
                                        />
                                        <div className="col-md-12 errorClass error_div">{props.errorFormData.hotel_state}</div>
                                    </div>
                                </ErrorBoundary>
                            </div>
                            <div className="col-md-4">
                                <ErrorBoundary title="CustomInput Error">
                                    <div className="dropdowninnerboxContainer">
                                        <label>City <span>*</span></label>
                                        <AutosuggestComponent
                                            handleOnChange={(e) => props.handelChange(e, 'hotel_city')}
                                            options={props.CityList}
                                            selectedValue={props.selectedCity}
                                            name='hotel_city'
                                            isMulti={false}
                                            placeholder=""
                                            isDisabled={false}
                                            isSearchable={true}
                                            menuPosition="fixed"
                                        />
                                        <div className="col-md-12 errorClass error_div">{props.errorFormData.hotel_city}</div>
                                    </div>
                                </ErrorBoundary>
                            </div>
                            <div className="col-md-4">
                                <ErrorBoundary title="CustomInput Error">
                                    <CustomInput
                                        parentClassName="input_field_inner"
                                        labelName="GSTIN"
                                        errorLabel={props.errorFormData.hotel_gstin_number}
                                        name="hotel_gstin_number"
                                        type="text"
                                        value={props.formData.hotel_gstin_number}
                                        labelPresent={true}
                                        onChange={(e) => props.handelChange(e, 'hotel_gstin_number')}
                                        requiredStar={false}
                                    />
                                </ErrorBoundary>
                            </div>
                            <div className="col-md-4">
                                <ErrorBoundary title="CustomInput Error">
                                    <CustomInput
                                        parentClassName="input_field_inner"
                                        labelName="PAN"
                                        errorLabel={props.errorFormData.hotel_pan_number}
                                        name="hotel_pan_number"
                                        type="text"
                                        value={props.formData.hotel_pan_number}
                                        labelPresent={true}
                                        onChange={(e) => props.handelChange(e, 'hotel_pan_number')}
                                        requiredStar={false}
                                    />
                                </ErrorBoundary>
                            </div>
                            <div className="col-md-4">
                                <div className="dropdowninnerboxContainer">
                                    <label>Timezone <span>*</span></label>
                                    <ErrorBoundary title="CustomInput Error">
                                        <TimezoneSelect
                                            value={props.formData.selectedTimezone || ""}
                                            onChange={(e) => props.handelChange(e, 'hotel_timezone')}
                                            className="timezone-select"
                                            classNamePrefix="dropdown-default"
                                        />
                                    </ErrorBoundary>
                                    <div className="col-md-12 errorClass error_div">{props.errorFormData.selectedTimezone}</div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="dropdowninnerboxContainer">
                                    <ErrorBoundary title="CustomInput Error">
                                        <CustomInput
                                            parentClassName="input_field_inner"
                                            labelName="Permissible Store Limit"
                                            errorLabel={props.errorFormData.max_branch}
                                            name="max_branch"
                                            type="text"
                                            value={props.formData.max_branch}
                                            labelPresent={true}
                                            onChange={(e) => props.handelChange(e, 'max_branch')}
                                            requiredStar={true}
                                        />
                                    </ErrorBoundary>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="row">
                            <div className='col-md-4'>
                                <div className="dropdowninnerboxContainer">
                                    <label>Version <span>*</span></label>
                                    <ErrorBoundary title="AutosuggestComponent Error">
                                        <AutosuggestComponent
                                            handleOnChange={(e) => props.handelChange(e, 'version')}
                                            options={props.versionList}
                                            selectedValue={props.selectedVersion}
                                            name=''
                                            isMulti={false}
                                            placeholder="Choose Version"
                                            isSearchable={true}
                                            classNamePrefix="dropdown-default"
                                            menuPosition="fixed"
                                        />
                                    </ErrorBoundary>
                                    <div className="col-md-12 errorClass error_div">{props.errorFormData.version}</div>
                                </div>
                            </div>
                            {/* <div className='col-md-4'>
                                <ErrorBoundary title="CustomInput Error">
                                    <CustomInput
                                        parentClassName="input_field_inner"
                                        labelName="Subdomain Name"
                                        errorLabel={props.errorFormData.domain}
                                        name="domain"
                                        type="text"
                                        value={props.formData.domain}
                                        labelPresent={true}
                                        onChange={(e) => props.handelChange(e, 'domain')}
                                    />
                                </ErrorBoundary>
                            </div> */}
                            {/* <div className='col-md-4'>
                                <div className='listingPrefaranceBox globallistingPrefaranceBox'>
                                    <div className='chkBoxPanelList'>
                                        <label className="chkContainer">
                                            <input type="checkbox"
                                                checked={props.formData.is_standalone}
                                                onChange={(e) => props.handelChange(e, "is_standalone")}
                                            />
                                            Global Listing Preference
                                            <span className="checkmark"></span>
                                        </label>
                                    </div>
                                </div>
                            </div> */}
                            {/* {props.selectedVersion?.value == "v4" && <div className='col-md-4'> */}
                            {<div className='col-md-4'>
                                <div className='mfaRequiredBoxes'>
                                    <div className='listingPrefaranceBox globallistingPrefaranceBox mfaRequiredBox' style={{ display: 'flex' }}>
                                        <div className='chkBoxPanelList'>
                                            <label className="chkContainer">
                                                <input type="checkbox"
                                                    checked={props.formData.is_mfa_required}
                                                    onChange={(e) => props.handelChange(e, "is_mfa_required")}
                                                />
                                                MFA Required
                                                <span className="checkmark"></span>
                                            </label>
                                        </div>
                                        <span className="infoIconBox"><OverlayTrigger trigger={['hover', 'click']} rootClose={true} overlay={<Tooltip className="my-custom-tooltip">MFA is required in organizations to add an extra layer of security, reducing the risk of unauthorized access by requiring multiple verification methods beyond just a password.</Tooltip>}><i className="fa fa-info-circle"></i></OverlayTrigger>
                                        </span>
                                    </div>

                                </div>
                            </div>}
                            {<div className='col-md-4'>
                                <div className='mfaRequiredBoxes'>
                                    <div className='listingPrefaranceBox globallistingPrefaranceBox mfaRequiredBox' style={{ display: 'flex' }}>
                                        <div className='chkBoxPanelList'>
                                            <label className="chkContainer">
                                                <input type="checkbox"
                                                    checked={props.formData.allow_main_store}
                                                    onChange={(e) => props.handelChange(e, "allow_main_store")}
                                                />
                                                Allow Central Hub
                                                <span className="checkmark"></span>
                                            </label>
                                        </div>
                                    </div>

                                </div>
                            </div>}

                            {/* {<div className='col-md-4'>
                                <div className='mfaRequiredBoxes'>
                                    <div className='listingPrefaranceBox globallistingPrefaranceBox mfaRequiredBox'>
                                        <div className='chkBoxPanelList'>
                                            <label className="chkContainer">
                                                <input type="checkbox"
                                                    checked={props.formData.is_agency}
                                                    onChange={(e) => props.handelChange(e, "is_agency")}
                                                />
                                                Is Agency
                                                <span className="checkmark"></span>
                                            </label>
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>} */}
                        </div>
                    </div>
                    <div className='col-md-12'>
                        <fieldset className='listingPrefaranceBox singleMulti'>
                            <legend><h2 className='title'>All Outbound emails should be sent from</h2></legend>
                            <div className='listingOption'>
                                <div className='chkBoxPanelList'>
                                    <label className="chkContainer">Admin's email
                                        <input type="radio" checked={props.formData.is_multi_threaded == 'singleThread' ? true : false} onChange={(e) => props.handelChange(e, 'singleThread')} name="radio" />
                                        <span className="checkmark"></span>
                                    </label>
                                    <label className="chkContainer">Branch Admin's email
                                        <input type="radio" name="radio" checked={props.formData.is_multi_threaded == 'multiThread' ? true : false} onChange={(e) => props.handelChange(e, 'multiThread')} />
                                        <span className="checkmark"></span>
                                    </label>
                                    <label className="chkContainer">Organizational representative
                                        <input type="radio" name="radio" checked={props.formData.is_multi_threaded == 'registerHotelRepresentative' ? true : false} onChange={(e) => props.handelChange(e, 'registerHotelRepresentative')} />
                                        <span className="checkmark"></span>
                                    </label>
                                </div>
                            </div>
                        </fieldset>
                    </div>
                    {/* {props.selectedVersion?.value == "v4" && <div className='col-md-12 listingPrefaranceBox alsoAgentBox'>
                        <div className='row'>
                            <div className='col-md-2 alsoAgentCheckedBox'>
                                <div className='chkBoxPanelList'>
                                    <label className="chkContainer">
                                        <input type="checkbox" id='alsoAgentBox'
                                            checked={props.isCheckedAgent}
                                            onChange={(e) => props.handleCheckboxChange(e)}
                                        />
                                        Is also an agent
                                        <span className="checkmark"></span>
                                    </label>
                                </div>
                            </div>
                            {props.isCheckedAgent &&
                                <fieldset className='agencyDetailsLegend'>
                                    <legend><h2>Agency Details</h2></legend>
                                    <div className='alsoAgentCheckedBox sameAs'>
                                        <div className='chkBoxPanelList'>
                                            <label className="chkContainer">
                                                <input type="checkbox" id=''
                                                    onChange={(e) => props.agentAdminSameAddress(e)}
                                                />
                                                Same as hotel
                                                <span className="checkmark"></span>
                                            </label>
                                        </div>
                                    </div>
                                    <div className='col-md-12'>
                                        <div className='row agencyDetailsBX'>
                                            <div className='col-md-12'>
                                                <div className='row' style={{ paddingBottom: '6px' }}>
                                                    <div className='col-md-8'>
                                                        <div className='row'>
                                                            <div className='col-md-6'>
                                                                <div className='listingOption'>
                                                                    <ErrorBoundary title="CustomInput Error">
                                                                        <CustomInput
                                                                            parentClassName="input_field_inner"
                                                                            labelName="Agency Name"
                                                                            errorLabel={props.errorFormData.agency_name}
                                                                            name="agencyName"
                                                                            type="text"
                                                                            value={props.formData.agency_name}
                                                                            labelPresent={true}
                                                                            onChange={(e) => props.handelChange(e, 'agency_name')}
                                                                        />
                                                                    </ErrorBoundary>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <ErrorBoundary title="CustomInput Error">
                                                                    <CustomInput
                                                                        parentClassName="input_field_inner"
                                                                        labelName="Email"
                                                                        errorLabel={props.errorFormData.agency_email}
                                                                        name="agency_email"
                                                                        type="text"
                                                                        value={props.formData.agency_email}
                                                                        labelPresent={true}
                                                                        onChange={(e) => props.handelChange(e, 'agency_email')}
                                                                    />
                                                                </ErrorBoundary>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <ErrorBoundary title="CustomInput Error">
                                                                    <CustomInput
                                                                        parentClassName="input_field_inner"
                                                                        labelName="Address 1"
                                                                        errorLabel={props.errorFormData.agency_address1}
                                                                        name="agency_address1"
                                                                        type="text"
                                                                        value={props.formData.agency_address1}
                                                                        labelPresent={true}
                                                                        onChange={(e) => props.handelChange(e, 'agency_address1')}
                                                                    />
                                                                </ErrorBoundary>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <ErrorBoundary title="CustomInput Error">
                                                                    <CustomInput
                                                                        parentClassName="input_field_inner"
                                                                        labelName="Address 2"
                                                                        errorLabel={props.errorFormData.agency_address2}
                                                                        name="agency_address2"
                                                                        type="text"
                                                                        value={props.formData.agency_address2}
                                                                        labelPresent={true}
                                                                        onChange={(e) => props.handelChange(e, 'agency_address2')}
                                                                        requiredStar={false}
                                                                    />
                                                                </ErrorBoundary>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-4 agencyDetailsBXLogo'>
                                                        <label className='logoLabel'>Agency Logo <span className='requiredStart'>*</span></label>
                                                        <div className="user_add_img modprofile hotel_img_container">
                                                            <div className="userProfileImg">
                                                                {!props.addHotelImagePreviewShow ?
                                                                    <OverlayTrigger overlay={<Tooltip> Upload Agency Logo</Tooltip>}>
                                                                        <label className="custom-file-upload">
                                                                            <span className="filetext">
                                                                                <img src={props.addHotelImageSelected} alt='111' />
                                                                            </span>
                                                                            <span className="plusicon">
                                                                                <i className="fa fa-plus" aria-hidden="true"></i>
                                                                                <input type="file" onChange={props.addInputHotelImageChanged} />
                                                                            </span>
                                                                        </label></OverlayTrigger> :
                                                                    <OverlayTrigger overlay={<Tooltip>Agency Logo</Tooltip>}>
                                                                        <label className="custom-file-upload">
                                                                            <img src={props.addHotelImageSelected} alt='222' />
                                                                            <span className="plusicon">
                                                                                <i className="fa fa-plus" aria-hidden="true"></i>
                                                                                <input type="file" onChange={props.addInputHotelImageChanged} />
                                                                            </span>
                                                                        </label></OverlayTrigger>}

                                                                <div className="col-md-12 errorClass error_div">{props.errorFormData.agency_image}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-md-12'>
                                                <div className='row'>
                                                    <div className="col-md-4">
                                                        <ErrorBoundary title="CustomInput Error">
                                                            <CustomInput
                                                                parentClassName="input_field_inner"
                                                                labelName="Zip Code"
                                                                errorLabel={props.errorFormData.agency_zipcode}
                                                                name="agency_zipcode"
                                                                type="text"
                                                                value={props.formData.agency_zipcode}
                                                                labelPresent={true}
                                                                onChange={(e) => props.handelChange(e, 'agency_zipcode')}
                                                            />
                                                        </ErrorBoundary>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <ErrorBoundary title="CustomInput Error">
                                                            <div className="dropdowninnerboxContainer">
                                                                <label>Country <span>*</span></label>
                                                                <AutosuggestComponent
                                                                    handleOnChange={(e) => props.handelChange(e, 'agency_country')}
                                                                    options={props.CountryListForAgency}
                                                                    selectedValue={props.selectedCountryForAgency}
                                                                    name=''
                                                                    isMulti={false}
                                                                    placeholder=""
                                                                    isDisabled={false}
                                                                    isSearchable={true}
                                                                    classNamePrefix="dropdown-default"
                                                                />
                                                            </div>
                                                            <div className="col-md-12 errorClass error_div">{props.errorFormData.agency_country}</div>
                                                        </ErrorBoundary>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className='input_field_inner_phone'>
                                                            <ErrorBoundary title="PhoneInput Error">
                                                                <PhoneNumberWithCountryCode
                                                                    country={props.selectedCountryCodeForAgency}
                                                                    value={props.formData.agency_contact_number}
                                                                    onChange={(e, country) => props.handelChange(e, 'agency_contact_number', country)}
                                                                    error={props.errorFormData.agency_contact_number}
                                                                    labelShow={true}
                                                                    requirStart={true}
                                                                    disableDropdown={true}
                                                                />
                                                            </ErrorBoundary>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <ErrorBoundary title="CustomInput Error">
                                                            <div className="dropdowninnerboxContainer">
                                                                <label>State <span>*</span></label>
                                                                <AutosuggestComponent
                                                                    handleOnChange={(e) => props.handelChange(e, 'agency_state')}
                                                                    options={props.StateListForAgency}
                                                                    selectedValue={props.selectedStateForAgency}
                                                                    name=''
                                                                    isMulti={false}
                                                                    placeholder=""
                                                                    isDisabled={false}
                                                                    isSearchable={true}
                                                                    classNamePrefix="dropdown-default"
                                                                />
                                                                <div className="col-md-12 errorClass error_div">{props.errorFormData.agency_state}</div>
                                                            </div>
                                                        </ErrorBoundary>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <ErrorBoundary title="CustomInput Error">
                                                            <div className="dropdowninnerboxContainer">
                                                                <label>City <span>*</span></label>
                                                                <AutosuggestComponent
                                                                    handleOnChange={(e) => props.handelChange(e, 'agency_city')}
                                                                    options={props.CityListForAgency}
                                                                    selectedValue={props.selectedCityForAgency}
                                                                    name='agency_city'
                                                                    isMulti={false}
                                                                    placeholder=""
                                                                    isDisabled={false}
                                                                    isSearchable={true}
                                                                />
                                                                <div className="col-md-12 errorClass error_div">{props.errorFormData.agency_city}</div>
                                                            </div>
                                                        </ErrorBoundary>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <ErrorBoundary title="CustomInput Error">
                                                            <CustomInput
                                                                parentClassName="input_field_inner"
                                                                labelName="GSTIN"
                                                                errorLabel={props.errorFormData.agency_gstin_number}
                                                                name="agency_gstin_number"
                                                                type="text"
                                                                value={props.formData.agency_gstin_number}
                                                                labelPresent={true}
                                                                onChange={(e) => props.handelChange(e, 'agency_gstin_number')}
                                                                requiredStar={false}
                                                            />
                                                        </ErrorBoundary>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <ErrorBoundary title="CustomInput Error">
                                                            <CustomInput
                                                                parentClassName="input_field_inner"
                                                                labelName="PAN"
                                                                errorLabel={props.errorFormData.agency_pan_number}
                                                                name="agency_pan_number"
                                                                type="text"
                                                                value={props.formData.agency_pan_number}
                                                                labelPresent={true}
                                                                onChange={(e) => props.handelChange(e, 'agency_pan_number')}
                                                                requiredStar={false}
                                                            />
                                                        </ErrorBoundary>
                                                    </div>
                                                    <div className='col-md-4'>
                                                        <div className='mfaRequiredBoxes mfaRequiredBoxesAgencyDetails'>
                                                            <div className='listingPrefaranceBox globallistingPrefaranceBox mfaRequiredBox'>
                                                                <div className='chkBoxPanelList'>
                                                                    <label className="chkContainer">
                                                                        <input type="checkbox"
                                                                            checked={props.formData.agency_mfa_required}
                                                                            onChange={(e) => props.handelChange(e, "agency_mfa_required")}
                                                                        />
                                                                        MFA Required
                                                                        <span className="checkmark"></span>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <span className="infoIconBox"><OverlayTrigger overlay={<Tooltip>MFA is required in organizations to add an extra layer of security, reducing the risk of unauthorized access by requiring multiple verification methods beyond just a password.</Tooltip>}><i className="fa fa-info-circle"></i></OverlayTrigger>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>
                            }
                        </div>
                    </div>} */}
                    {/* <div className='col-md-12'>
                        <h3 className='admin_details_label admin_details_top_space'>Admin Details</h3>
                        <div className='divider_row'></div>
                    </div>
                    <div className='col-md-12'>
                        <div className='row'>
                            <div className='col-md-9'>
                                <div className='row'>
                                    <div className="col-md-6">
                                        <ErrorBoundary title="CustomInput Error">
                                            <CustomInput
                                                parentClassName="input_field_inner"
                                                labelName={props.t('firstname')}
                                                errorLabel={props.errorFormData.first_name}
                                                name="firstName"
                                                type="text"
                                                value={props.formData.first_name}
                                                labelPresent={true}
                                                onChange={(e) => props.handelChange(e, 'first_name')}
                                            />
                                        </ErrorBoundary>
                                    </div>
                                    <div className="col-md-6">
                                        <ErrorBoundary title="CustomInput Error">
                                            <CustomInput
                                                parentClassName="input_field_inner"
                                                labelName="Last Name"
                                                errorLabel={props.errorFormData.last_name}
                                                name="name"
                                                type="text"
                                                value={props.formData.last_name}
                                                labelPresent={true}
                                                onChange={(e) => props.handelChange(e, 'last_name')}
                                            />
                                        </ErrorBoundary>
                                    </div>
                                    <div className="col-md-6">
                                        <ErrorBoundary title="CustomInput Error">
                                            <CustomInput
                                                parentClassName="input_field_inner"
                                                labelName={props.t('Email')}
                                                errorLabel={props.errorFormData.email}
                                                name="email"
                                                type="text"
                                                value={props.formData.email}
                                                labelPresent={true}
                                                onChange={(e) => props.handelChange(e, 'email')}
                                                readOnly={props.editedHotelFlag ? true : false}
                                            />
                                        </ErrorBoundary>
                                    </div>
                                    <div className="col-md-6">
                                        <div className='input_field_inner_phone'>
                                            <ErrorBoundary title="PhoneInput Error">
                                                <PhoneNumberWithCountryCode
                                                    country={props.selectedCountryCode}
                                                    value={props.formData.contact_number}
                                                    onChange={(e, country) => props.handelChange(e, 'contact_number', country)}
                                                    error={props.errorFormData.contact_number}
                                                    labelShow={true}
                                                    requirStart={true}
                                                />
                                            </ErrorBoundary>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="user_add_img modprofile userprofile_img">
                                    <div className="userProfileImg">
                                        {!props.addProfileImagePreviewShow ?
                                            <OverlayTrigger overlay={<Tooltip>Upload Admin Image</Tooltip>}>
                                                <label className="custom-file-upload">
                                                    <span className="filetext">
                                                        <img src={props.addprofileImageSelected}
                                                        />
                                                    </span>
                                                    <span className="plusicon">
                                                        <i className="fa fa-plus" aria-hidden="true"></i>
                                                        <input type="file" accept={Utility.acceptFileType()} onChange={props.addInputProfileImageChanged} />
                                                    </span>
                                                </label></OverlayTrigger> :
                                            <OverlayTrigger overlay={<Tooltip>Admin Image</Tooltip>}>
                                                <label className="custom-file-upload">
                                                    <img src={props.addprofileImageSelected} />
                                                    <span className="plusicon">
                                                        <i className="fa fa-plus" aria-hidden="true"></i>
                                                        <input type="file" accept={Utility.acceptFileType()} onChange={props.addInputProfileImageChanged} />
                                                    </span>
                                                </label></OverlayTrigger>}

                                        <div className="col-md-12 errorClass error_div">{props.errorFormData.profile_image}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> */}
                </div>
                <div className="col-md-12 text-center topspace">
                    <button type="button" className="modBtnSave" onClick={(e) => props.hotelDataSave()}>{!props.editedHotelFlag ? props.t('save') : "Update"}</button>
                    <button type="button" className="modBtnSave cancelbtn" onClick={(e) => props.closeHotelModal()}>Cancel</button>
                </div>
            </div>
            {/* for Agency image crop modal */}
            <ErrorBoundary title="ModalGlobal Error">
                <ModalGlobal
                    show={props.hotelImageCropModalFlag}
                    onHide={props.hotelImageCropModalHide}
                    onCancel={props.hotelImageCropModalHide}
                    onSave={props.hotelImageCropDataSave}
                    className="modalcustomizeDialog cropmodalcontentDialog"
                    bodyClassName="cropmodalcontentbody"
                    headerclassName="close_btn_icon"
                    title={props.t('cropimage')}
                    footer={true}
                    closeButton={true}
                    saveButtonLabel={props.t('crop')}
                    saveButtonClassName="delconfirmbtn btn btn-primary"
                    cancelButtonClassName="delcancelbtn btn btn-primary"
                    body={
                        <>
                            <ErrorBoundary title="ModalGlobal Error">
                                <ImageCropContent
                                    onImageLoaded={props.onHotelImageLoaded}
                                    onComplete={props.onHotelCropComplete}
                                    onCropChange={props.onCropChangeHotel}
                                    crop={props.hotelCrop}
                                    croppedImageUrl={props.hotelCroppedImageUrl}
                                    src={props.hotelSrc}
                                    onCropComplete={props.onHotelCropComplete}
                                    imageCropModalShow={props.hotelImageCropModalShow}
                                    circularCrop={props.circularCrop}
                                />
                            </ErrorBoundary>
                        </>
                    }
                />
            </ErrorBoundary>

            {/* for admin image crop modal */}
            <ErrorBoundary title="ModalGlobal Error">
                <ModalGlobal
                    show={props.imageCropModalFlag}
                    onHide={props.imageCropModalHide}
                    onCancel={props.imageCropModalHide}
                    onSave={props.imageCropDataSave}
                    className="modalcustomizeDialog cropmodalcontentDialog"
                    bodyClassName="cropmodalcontentbody"
                    headerclassName="close_btn_icon"
                    title={props.t('cropimage')}
                    footer={true}
                    closeButton={true}
                    saveButtonLabel={props.t('crop')}
                    saveButtonClassName="delconfirmbtn btn btn-primary"
                    cancelButtonClassName="delcancelbtn btn btn-primary"
                    body={
                        <>
                            <ErrorBoundary title="ModalGlobal Error">
                                <ImageCropContent
                                    onImageLoaded={props.onImageLoaded}
                                    onComplete={props.onCropComplete}
                                    onCropChange={props.onCropChange}
                                    crop={props.crop}
                                    croppedImageUrl={props.croppedImageUrl}
                                    src={props.src}
                                    onCropComplete={props.onCropComplete}
                                    imageCropModalShow={props.imageCropModalShow}
                                    circularCrop={false}
                                />
                            </ErrorBoundary>
                        </>
                    }
                />
            </ErrorBoundary>
        </div>
    );
};

const mapStateToProps = (globalState) => {
    return {
        userCredentials: globalState.LoginReducer.userCredentials,
        token: globalState.LoginReducer.token
    };
}

export default connect(mapStateToProps, { handleActiveLink, loaderStateTrue, loaderStateFalse })(withNamespaces()(HotelAddEditModalContent));
